// Figma: 6406:46549 — see stories/blocks/two-tone-quote-reveal.stories.tsx
"use client";

import {
  ScrollRevealMuted,
  ScrollRevealText,
} from "@/components/ui/scroll-reveal-text";

/**
 * Two-tone quote reveal — the lead/trail colour split falls wherever the copy
 * wraps (Figma 6406:46549), so the quote fills its container instead of being
 * forced onto separate lines at the split.
 */
export function TwoToneQuoteReveal({
  quoteLead,
  quoteTrail,
  mutedClassName = "text-grey-600",
}: {
  quoteLead: string;
  quoteTrail: string;
  mutedClassName?: string;
}) {
  return (
    <ScrollRevealText variant="light" as="span" className="text-balance">
      {quoteLead.trimEnd()}{" "}
      <ScrollRevealMuted className={mutedClassName}>
        {quoteTrail}
      </ScrollRevealMuted>
    </ScrollRevealText>
  );
}
